<script setup>
import { Infinity, SlidersHorizontal, CalendarDays } from 'lucide-vue-next'

defineProps({
  icon: {
    type: String,
    required: true
  },
  text: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: 'blue'
  }
})

const icons = {
  infinity: Infinity,
  sliders: SlidersHorizontal,
  calendar: CalendarDays
}

const colorConfig = {
  blue: 'from-blue-500 to-blue-600',
  purple: 'from-purple-500 to-purple-600',
  green: 'from-green-500 to-green-600'
}
</script>

<template>
  <div class="flex items-center gap-3 bg-white rounded-full w-full md:w-auto px-6 py-3 shadow-md">
    <div :class="['w-10 h-10 bg-gradient-to-br rounded-full flex items-center justify-center', colorConfig[color]]">
      <component :is="icons[icon]" class="text-white w-5 h-5" />
    </div>
    <span class="text-gray-900 font-semibold">{{ text }}</span>
  </div>
</template>
